import { render, staticRenderFns } from "./Brokers1.container.vue?vue&type=template&id=cb449a7c&scoped=true&"
import script from "./Brokers1.container.vue?vue&type=script&lang=js&"
export * from "./Brokers1.container.vue?vue&type=script&lang=js&"
import style0 from "./Brokers1.container.vue?vue&type=style&index=0&id=cb449a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb449a7c",
  null
  
)

export default component.exports